import { useEffect, useRef } from 'react';

import useExercise from '../../hooks/useExercise.hook';

const ExercisesComponent = () => {
    const { exercise, sequence, instrument, start, createSequence, createNotes, createPattern } = useExercise();
    const lastRequestedExercise = useRef(null);
    const instrumentKey = `${instrument.id}:${instrument.openStringMidi.join(',')}`;
    const requestKey = `${exercise}:${instrumentKey}`;
    
    useEffect(() => {
        // React StrictMode replays effects in development. Avoid racing duplicate worker requests.
        if (!sequence.length && lastRequestedExercise.current !== requestKey) {
            lastRequestedExercise.current = requestKey;
            createSequence();
        }
    }, [exercise, instrumentKey, sequence.length, createSequence, requestKey]);

    useEffect(() => {
        if (sequence.length) {
            createNotes();
            createPattern();
        }
    }, [exercise, instrument, sequence, start]);

    return null;
};

export default ExercisesComponent;